var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-chart" },
    [
      _c("div", { staticClass: "modal-chart__legend" }, [
        _c("p", [_vm._v("Основные виды реализуемых услуг/продукции:")]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "list" },
          _vm._l(_vm.chartLabels, function (e, i) {
            return _c("li", { key: i, staticClass: "item" }, [
              _c("div", {
                staticClass: "item__marker",
                style: { background: _vm.bgColorsList[i] },
              }),
              _vm._v(" \n                " + _vm._s(e) + "\n            "),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("chart", {
        ref: "modalChart",
        staticClass: "modal-chart__pie no_print",
        attrs: {
          type: "pie",
          data: _vm.chartData,
          options: _vm.modalPieOptions,
        },
      }),
      _vm._v(" "),
      _c("div", { ref: "imgContainer", staticClass: "chart-img-for-print" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }